import {
  DEFAULT_IMAGE_DURATION_MS,
  DEFAULT_MESSAGE_DURATION_MS,
  DEFAULT_WEATHER_DURATION_MS,
  MAX_SLIDE_DURATION_MS,
  MIN_SLIDE_DURATION_MS,
} from "@mem/shared";

export const MIN_DURATION_SEC = Math.round(MIN_SLIDE_DURATION_MS / 1000);
export const MAX_DURATION_SEC = Math.round(MAX_SLIDE_DURATION_MS / 1000);

export interface QuickTimingSecState {
  messageDurationSec: number;
  imageDurationSec: number;
  weatherDurationSec: number;
}

function toNumber(value: unknown): number | null {
  if (typeof value !== "number" || !Number.isFinite(value)) return null;
  return value;
}

export function clampDurationSec(value: number): number {
  if (!Number.isFinite(value)) return MIN_DURATION_SEC;
  if (value < MIN_DURATION_SEC) return MIN_DURATION_SEC;
  if (value > MAX_DURATION_SEC) return MAX_DURATION_SEC;
  return Math.round(value);
}

function msToSecWithFallback(value: unknown, fallbackMs: number): number {
  const ms = toNumber(value) ?? fallbackMs;
  return clampDurationSec(ms / 1000);
}

export function timingSecFromSource(
  source?: {
    messageDurationMs?: unknown;
    imageDurationMs?: unknown;
    weatherDurationMs?: unknown;
  } | null,
): QuickTimingSecState {
  return {
    messageDurationSec: msToSecWithFallback(
      source?.messageDurationMs,
      DEFAULT_MESSAGE_DURATION_MS,
    ),
    imageDurationSec: msToSecWithFallback(
      source?.imageDurationMs,
      DEFAULT_IMAGE_DURATION_MS,
    ),
    weatherDurationSec: msToSecWithFallback(
      source?.weatherDurationMs,
      DEFAULT_WEATHER_DURATION_MS,
    ),
  };
}
